import styled from "styled-components";

import { breakpoints } from "./constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  font-family: var(--font-family-sans);
  color: var(--color-default-text);
  width: 100%;
  height: 100%;
  background: var(--gray50);

  & > div.content {
    box-sizing: border-box;
    max-width: ${breakpoints.desktopWide}px;
    margin: 0 auto;
    padding: calc(var(--space-unit) * 2);
  }

  .nav {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    & > div.content {
      padding: calc(var(--space-unit) * 3);
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
  }

  /* Desktop wide breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
    & > div.content {
      padding: calc(var(--space-unit) * 4);
    }
  }
`;
